const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Pestilence extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.Pestilence,
            "Each civilization loses 1 population.",
            {}
        )
    }
}

module.exports = Pestilence;